/**
 * "Request sent" (24 Oct 2026, Jasmine): someone who already has a Learnbee account signs in through
 * an organisation's code without being invited. The code sends that organisation's admins a request —
 * but they used to land straight in their own organisation with a 3-second toast as the only sign,
 * which read as "the code just dropped me into Learnbee". Now a clear page first, then on in.
 * (Someone with no organisation of their own gets NoAccess's "Waiting for X to approve you".)
 */
import { Send } from 'lucide-react'

export function RequestSent({ orgName, onContinue }: { orgName: string; onContinue: () => void }) {
  return (
    <div style={{ minHeight: '100dvh', background: '#F7F7FA', display: 'grid', placeItems: 'center', padding: 16 }}>
      <div role="status" style={{ width: '100%', maxWidth: 440, background: '#fff', border: '1px solid #E7E7EE', borderRadius: 20, padding: '32px 28px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 12, boxShadow: '0 10px 30px rgba(28,26,34,.06)' }}>
        <span aria-hidden style={{ width: 52, height: 52, borderRadius: 14, background: '#EFEAFB', color: '#6741D9', display: 'grid', placeItems: 'center' }}><Send size={22} /></span>
        <h1 style={{ margin: '8px 0 0', fontSize: 22, fontWeight: 700, color: '#16141C' }}>Request sent to {orgName}</h1>
        <p style={{ margin: 0, fontSize: 15, lineHeight: 1.55, color: '#5B5866' }}>
          An admin needs to approve it. You’ll get an email when they do.
        </p>
        <button onClick={onContinue} autoFocus
          style={{ marginTop: 12, height: 48, width: '100%', borderRadius: 12, border: 'none', background: '#6741D9', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
          Go to Learnbee
        </button>
      </div>
    </div>
  )
}
